export const prodEnvFlags = {
    geolocationBannerActions: false,
    parkingDiscountBanner: false,
    parkingPackages: true,
    communityParkings: false,
    partnersIntegration: false,
    gates: false,
};
